import React, { useState } from 'react';

const ContactsPage = ({ active, contacts, onAddContact, onDeleteContact }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortKey, setSortKey] = useState(null);
  const [sortAsc, setSortAsc] = useState(true);

  const handleSort = (key) => {
    if (sortKey === key) setSortAsc(!sortAsc);
    else { setSortKey(key); setSortAsc(true); }
  };

  let filtered = contacts.filter(c =>
    (c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.company.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.email.toLowerCase().includes(searchQuery.toLowerCase())) &&
    (statusFilter === 'all' || c.status === statusFilter)
  );

  if (sortKey) {
    filtered = [...filtered].sort((a, b) =>
      sortAsc ? String(a[sortKey]).localeCompare(String(b[sortKey])) : String(b[sortKey]).localeCompare(String(a[sortKey]))
    );
  }

  return (
    <section className={`section ${active ? 'active' : ''}`} data-testid="contacts-section">
      <div className="section-header">
        <div>
          <div className="section-title">Contact Database</div>
          <div className="section-subtitle">Manage and track all client relationships</div>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button className="btn btn-ghost" data-testid="export-contacts-btn">↓ Export</button>
          <button className="btn btn-gold" onClick={onAddContact} data-testid="open-add-contact-btn">+ Add Contact</button>
        </div>
      </div>
      <div className="table-toolbar">
        <div className="search-box">
          <span style={{ color: 'var(--text-muted)' }}>⊘</span>
          <input
            type="text"
            placeholder="Search name, company or email..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            data-testid="contact-search-input"
          />
        </div>
        <select
          className="form-control form-select filter-select"
          style={{ maxWidth: '180px' }}
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
          data-testid="contact-status-filter"
        >
          <option value="all">All Status</option>
          <option value="hot">Hot</option>
          <option value="warm">Warm</option>
          <option value="cold">Cold</option>
        </select>
      </div>
      <div className="glass-panel">
        <div className="panel-body">
          <table className="crm-table">
            <thead>
              <tr>
                <th onClick={() => handleSort('name')}>Client Name ⇅</th>
                <th onClick={() => handleSort('position')}>Position ⇅</th>
                <th onClick={() => handleSort('company')}>Company ⇅</th>
                <th>Email</th>
                <th>Phone</th>
                <th onClick={() => handleSort('lastContact')}>Last Contact ⇅</th>
                <th onClick={() => handleSort('status')}>Status ⇅</th>
                <th style={{ textAlign: 'center' }}>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? filtered.map(c => (
                <tr key={c.id} data-testid={`contact-row-${c.id}`}>
                  <td>
                    <div className="td-name">
                      <div className="contact-avatar" style={{ background: `${c.color}22`, color: c.color, border: `1px solid ${c.color}44` }}>
                        {c.initials}
                      </div>
                      <span style={{ fontWeight: '500' }}>{c.name}</span>
                    </div>
                  </td>
                  <td style={{ color: 'var(--text-secondary)' }}>{c.position}</td>
                  <td>{c.company}</td>
                  <td style={{ color: 'var(--text-secondary)', fontFamily: "'JetBrains Mono'", fontSize: '12px' }}>{c.email}</td>
                  <td style={{ color: 'var(--text-secondary)', fontFamily: "'JetBrains Mono'", fontSize: '12px' }}>{c.phone}</td>
                  <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--text-muted)' }}>{c.lastContact}</td>
                  <td><span className={`badge badge-${c.status}`}>{c.status.toUpperCase()}</span></td>
                  <td style={{ textAlign: 'center' }}>
                    <button
                      className="btn-icon-danger"
                      onClick={() => onDeleteContact(c.id)}
                      title="Hapus"
                      data-testid={`delete-contact-btn-${c.id}`}
                    >🗑</button>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '30px' }}>
                    Tidak ada kontak ditemukan.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ContactsPage;
